module.exports = __webpack_public_path__ + "img/silenced_icon.57cdf23d.svg";